import {
    GET_PARTNER_SITES_REQUESTED,
    GET_PARTNER_SITES_REJECTED,
    GET_PARTNER_SITES_FULFILLED,
} from '../actions/types';

const initialState = {
    currentSite: null,
    partnerSites: {
        inProgress: false,
        success: '',
        error: '',
        data: null,
    },
}

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_PARTNER_SITES_REQUESTED: {
            const { inProgress } = action;
            return Object.assign({}, state, {
                partnerSites: {
                    inProgress
                }
            });
        }
        case GET_PARTNER_SITES_REJECTED: {
            const { inProgress, success, error } = action;
            return Object.assign({}, state, {
                partnerSites: {
                    inProgress,
                    success,
                    error
                }
            });
        }
        case GET_PARTNER_SITES_FULFILLED: {
            const { inProgress, success, error, data } = action;
            if(data.success){
                return Object.assign({}, state, {
                    partnerSites: {
                        inProgress,
                        success,
                        error,
                        data: data.partnerSites[0]
                    }
                });
            }else{
                return Object.assign({}, state, {
                    partnerSites: {
                        inProgress,
                        success: false,
                        error: true,
                        data: null
                    }
                });
            }
        }
        
        default:
            return state;
    }
  };
  